import React, { Component, Fragment, useEffect, useState } from "react";
import * as stdActions from "../../redux/actions/stdAction";
import Pagination from "../Std/Pagination";
import * as utilities from "../../utilities/utils";
import moment from "moment";
import DropdownComponent from "../../containers/Dropdown";
import { ATTACHMENT_FILTER, PAGE_SIZE_DRP } from "../../App.config";
import DownloadSvg from "../../images/download.svg";
import handSvg from "../../images/hand.svg";
import history from "../../utilities/history";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import * as attachmentsActions from "../../redux/actions/attachmentsAction";
import StdAcmdCasestatusComponent from "./StdAcmdCaseStatusComponent";
import AirCasestatusComponent from "./AirCaseStatusComponent";
import SearchComponent from '../SearchComponent';

const CaseStatusComponent = (props, context) => {
  const [state, forceUpdate] = useState(0);
  const [search, setSearch] = useState("");
  const [rowIndex, setRowIndex] = useState(-1);

  const dispatch = useDispatch();
  const attachmentsAction = bindActionCreators(attachmentsActions, dispatch);
  const attachmentsReducer = useSelector((state) => state.attachmentsReducer);
  const profileReducer = useSelector((state) => state.profileReducer);

  useEffect(() => {
    attachmentsAction.setAllCaseStatusDetails([]);
  }, []);

  useEffect(() => {
    if (props.caseStatusDetails.length > 0 && attachmentsReducer.caseStatusDeatils.length > 0) {
      let allCasesDetails = attachmentsReducer.caseStatusDeatils;
      if(props.caseStatusDetails[rowIndex])
          props.caseStatusDetails[rowIndex].allCases = allCasesDetails;
      forceUpdate(state + 1);
    }
  }, [attachmentsReducer.caseStatusDeatils]);

  //Here we need to call allcase status api
  //Cases comes for particular EIN
  const getAllCasesByEIn = (index, ein) => {
    if (rowIndex === index) {
      delete props.caseStatusDetails[index].allCases;
      setRowIndex(-1);
      attachmentsAction.setAllCaseStatusDetails([]);
    }
    else {
      let caseDetail = props.caseStatusDetails[rowIndex];
      if (caseDetail) {
        delete props.caseStatusDetails[rowIndex].allCases;
      }
      setRowIndex(index);
      attachmentsAction.getAllCasesDetailsByEin(ein, {
        pageNo: 1,
        pageSize: 1000,
        totalRows: 0,
      }, profileReducer);
    }

  }

  const addRow = (i) => {
    if (props.caseStatusDetails[rowIndex].allCases[i].otherData) {
      delete props.caseStatusDetails[rowIndex].allCases[i].otherData;
    } else {
      props.caseStatusDetails[rowIndex].allCases[i].otherData = {
        DateCaseOpened: props.caseStatusDetails[rowIndex].allCases[i].dateCaseOpened,
        PreviousHistory:
          props.caseStatusDetails[rowIndex].allCases[i].prevHistoryWithOncEmployment,
        CaseNumber: props.caseStatusDetails[rowIndex].allCases[i].caseMgmtID,
        CaseType: props.caseStatusDetails[rowIndex].allCases[i].caseType,
        CaseManager: props.caseStatusDetails[rowIndex].allCases[i].managedBy,
        NumberOfOpenDays: props.caseStatusDetails[rowIndex].allCases[i].daysLost,
        NumberOfOpenDaysBussiness: props.caseStatusDetails[rowIndex].allCases[i].daysLostBusiness,
        PhysicianStatement: props.caseStatusDetails[rowIndex].allCases[i].attendingPhyStatRecDate,
        FileStatusInfo: props.caseStatusDetails[rowIndex].allCases[i].fileStatusInformation,
        DateOfMedicalUpdates:
          props.caseStatusDetails[rowIndex].allCases[i].datesMedicalUpdatesReceived,
        DateEmployerStatementReceived:
          props.caseStatusDetails[rowIndex].allCases[i].dateEmployerStatementReceived,
        DateOfReductioninBenefits: props.caseStatusDetails[rowIndex].allCases[i].payReductionDate,
        DateCasebecame: props.caseStatusDetails[rowIndex].allCases[i].complexCaseDate,
        FirstDayAbsent: props.caseStatusDetails[rowIndex].allCases[i].firstDayAbsentFromWork,
        CaseStatus: props.caseStatusDetails[rowIndex].allCases[i].caseStatus,
        RestrictionsLimitations: props.caseStatusDetails[rowIndex].allCases[i].restrictions,
        ExpectedRTWDate: props.caseStatusDetails[rowIndex].allCases[i].xRTW,
        RTWDates: null,
        EIDates: props.caseStatusDetails[rowIndex].allCases[i].eiDates,
        STDExpiryDate: props.caseStatusDetails[rowIndex].allCases[i].stdExpiryDate,
        payReductionDate: props.caseStatusDetails[rowIndex].allCases[i].payReductionDate,
        DateClosed: null,
        LastUpdate: props.caseStatusDetails[rowIndex].allCases[i].lastUpdateFileStatusDate,
        NextAction: props.caseStatusDetails[rowIndex].allCases[i].nextAction,

        location: props.caseStatusDetails[rowIndex].allCases[i].location,
        dateAIRSubmitted: props.caseStatusDetails[rowIndex].allCases[i].dateAIRSubmitted,
        isAIRCaseOpen: props.caseStatusDetails[rowIndex].allCases[i].isAIRCaseOpen,
        claimTypeAIR: props.caseStatusDetails[rowIndex].allCases[i].claimTypeAIR,
        dateOfIncident: props.caseStatusDetails[rowIndex].allCases[i].dateOfIncident,
        dateLostTimeBegan: "-",
        dateEmployeeReturnedToWork: props.caseStatusDetails[rowIndex].allCases[i].dateEmployeeReturnedToWork,
        rtwAIRStatus: props.caseStatusDetails[rowIndex].allCases[i].rtwAIRStatus,
        airFileStatus: props.caseStatusDetails[rowIndex].allCases[i].airFileStatus,
        claimStatus: props.caseStatusDetails[rowIndex].allCases[i].airClaimStatus,
        airNextAction: props.caseStatusDetails[rowIndex].allCases[i].nextAction,
        followUpDate: props.caseStatusDetails[rowIndex].allCases[i].followUpDate,

        isAIR: props.caseStatusDetails[rowIndex].allCases[i].isAIR,
      };
    }

    forceUpdate(state + 1);
  };

  const onDropDownChange = (event) => {
    let { name, value } = event;

    if (value.length) {
      props.onPageSizeChange(utilities.extractFirstValueOfArray(value));
    }
  };

  const onChange = (event) => {
    props.onChange({ name: event.target.name, value: event.target.value });
  };

  const handleAllDownload = () => {
    props.downloadAllAttachments(props.ein, props.isCustomAttachment);
  };

  const onSearch = () => {
    if (search.trim()) {
      props.getSearchCaseStatus(search.trim());
    } else {
      props.getSearchCaseStatus(null);
    }
  };

  const handleChanges = (e) => {
    setSearch(e.target.value);
  }
  return (
    <>
      <div className="Inner-cell">
        <div className="Panel-cell">
          <div className="Card-panel">
            <div className="table-header">
              <div className="pagesize-dropdown">
                <DropdownComponent
                  name="pageSize"
                  options={PAGE_SIZE_DRP}
                  isMultiSelect={false}
                  option_key="pageSize"
                  option_display="pageSizeValue"
                  onChange={onDropDownChange}
                  values={[props.pageSize]}
                  simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                  selectAllText="Select All Options"
                  isSearchOption={false}
                />
              </div>
              {/* <div className="row">
                <div className="search-panel">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 search-container">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-11 search-text">
                      <input
                        type="text"
                        placeholder={props.context.t("CurrentActivity.Search.Text")}
                        className="form-control"
                        value={search}
                        name="search"
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                    <div className="search-text">
                      <a
                        id="case-status-search"
                        tabIndex="0"
                        onClick={onSearch}
                        className="btn btn-search"
                      >
                        {props.context.t("CurrentActivity.Search.Text")}
                      </a>
                    </div>
                  </div>
                </div>
              </div> */}
              <div class="row">
              <SearchComponent  searchKeyword={search} handleChanges={handleChanges} context={props.context} onSearch={onSearch}/>
            </div>
            </div>
            <div className="Table-list">
              <div className="Table-head">
                <div className="Table-cell">
                  <table className="table ">
                    <thead>
                      <tr>
                        <th>{props.context.t("STD-Employer-Statement.form.Employee-Details.label.text.EEName")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.caseStatusDetails
                        ? props.caseStatusDetails.map((status, index) => (
                          status.employeeId && <Fragment key={`status-${index}`}>
                            <tr
                              className="case-status-tb-row bg-orange"
                              onClick={() => { getAllCasesByEIn(index, status.employeeId) }}
                            >
                              <td>
                                {status.fullName}
                              </td>
                            </tr>
                            {(Array.isArray(status.allCases) && status.allCases && status.allCases.length > 0) &&
                              (
                                <div>
                                  <StdAcmdCasestatusComponent context={props.context} addRow={addRow} allCases={status.allCases} />
                                  <AirCasestatusComponent context={props.context} addRow={addRow} allCases={status.allCases} />
                                </div>
                              )
                            }
                          </Fragment>
                        ))
                        : null}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="table-footer">
                <span htmlFor="">{props.context.t("Attachment.TotalRows.Text")}: {props.totalRows}</span>

                <Pagination
                  currentPage={props.currentPage}
                  pageSize={props.pageSize}
                  totalRows={props.totalRows}
                  onClickPre={(pageNo) => {
                    onChange({
                      target: {
                        name: "currentPage",
                        value: pageNo,
                      },
                    });
                  }}
                  onClickNext={(pageNo) => {
                    onChange({
                      target: {
                        name: "currentPage",
                        value: pageNo,
                      },
                    });
                  }}
                  onClickPage={(pageNo) => {
                    onChange({
                      target: {
                        name: "currentPage",
                        value: pageNo,
                      },
                    });
                  }}
                ></Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CaseStatusComponent;
